import React, { FC } from 'react';

import PromoListSkeleton from '../../PromoListSkeleton';
import PromoVirtualizedList from '../PromoVirtualizedList';
import PromoEmptyState from '../PromoEmptyState';
import PromoErrorState from '../PromoErrorState';
import type { PromoOptionsContentProps } from './types';

const PromoOptionsContent: FC<PromoOptionsContentProps> = ({
  hasNextPage,
  isInitialLoading,
  isBulkSelectionActionPending,
  items,
  queryError,
  queryKey,
  onLoadMore,
  onPromoPlaybackToggle,
  onPromoSelectionChange,
  onRetry,
}) => {
  if (isInitialLoading) {
    return <PromoListSkeleton />;
  }

  if (items.length === 0) {
    if (queryError) {
      return <PromoErrorState onRetry={onRetry} />;
    }

    return <PromoEmptyState />;
  }

  return (
    <>
      {queryError && (
        <PromoErrorState
          isInline
          onRetry={onRetry}
        />
      )}
      <PromoVirtualizedList
        hasNextPage={hasNextPage}
        isBulkSelectionActionPending={isBulkSelectionActionPending}
        items={items}
        queryKey={queryKey}
        onLoadMore={onLoadMore}
        onPromoPlaybackToggle={onPromoPlaybackToggle}
        onPromoSelectionChange={onPromoSelectionChange}
      />
    </>
  );
};

export default PromoOptionsContent;
